import { Table, Modal, Button, Spin, Avatar, Input, Select } from "antd";
import { useState, useEffect } from "react";
import { MdAdd, MdClose, MdPostAdd, MdPrint, MdReport } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { API_BASE_URL } from "../../../../../api";
// import { GetPatients } from "../../../../../Redux/Datas/action";
import { redirect, useNavigate } from "react-router-dom";
import { Search, SortAscIcon } from "lucide-react";
import { toast } from "react-toastify";
import Sidebar from "../../GlobalFiles/Sidebar";
import axios from "axios";


const Report = () => {
  const [loading, setLoading] = useState(false);
  const [reports, setReports] = useState([]);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalColumns, setModalColumns] = useState([]);
  const [currentView, setCurrentView] = useState("table");
  const [selectedRecord, setSelectedRecord] = useState(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [sortBy, setSortBy] = useState("");

  const { dashboard: { data } } = useSelector((store) => store.data);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: { user }, } = useSelector((state) => state.auth);
  const isManager = user?.userType === "manager";

  useEffect(() => {
    if (!user || !isManager) {
      toast.error("Unauthorized", { toastId: "unauthorized" });
      navigate('/');
      return;
    }

    // dispatch(GetPatients());
    const fetchAllData = async () => {
      setLoading(true);
      await fetchReports();
      setLoading(false);
    };
    fetchAllData();
  }, [dispatch]);


  const fetchReports = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/reports?status=pending&depth=2`);
      // console.log("Fetched reports:", response.data);
      setReports(response.data || []);
      return response.data;
    } catch (error) {
      console.error("Error fetching reports:", error);
      return [];
    }
  };


  useEffect(() => {
    let sorted = [...reports];

    if (sortBy) {
      const [key, order] = sortBy.split(':');
      sorted.sort((a, b) => {
        const dateA = new Date(key === 'createdAt' ? a.createdAt : a.updatedAt);
        const dateB = new Date(key === 'createdAt' ? b.createdAt : b.updatedAt);
        return order === 'asc' ? dateA - dateB : dateB - dateA;
      });
    }
    // console.log("Sorted Reports: ", sorted);
    setReports(sorted);
  }, [sortBy]);


  const showModal = async (_title) => {
    if (!reports || reports.length === 0) {
      toast.warning("No pending reports found", { toastId: "no-reports" });
      return;
    }

    setIsModalVisible(true);
    setModalLoading(true);
    setCurrentView("table");
    setSelectedRecord(null);

    let columns = [];
    let data = [];

    columns = [
      {
        title: "Image",
        key: "image",
        render: (_, record) => <Avatar src={record.patient?.image || record.image || "/user.png"} />
      },
      // { title: "Patient ID", key: "patientID", render: (_, record) => record.patient?.patientID || record.patient?._id || '-' },
      { title: "Name", key: "patientName", render: (_, record) => record.patient?.patientName || record.patientName || '-' },
      { title: "Age", key: "age", render: (_, record) => record.patient?.age || record.age || '-' },
      { title: "Date", key: "date", render: (_, record) => { new Date(record.patient?.createdAt || record.date || '-').toDateString() } },
      { title: "Gender", key: "gender", render: (_, record) => record.patient?.gender || record.gender || '-' },
      { title: "Address", key: "address", render: (_, record) => record.patient?.address || record.address || '-' },
      { title: "Status", key: "status", render: (_, record) => <span className="p-1 rounded-lg bg-yellow-400 text-white">{record.patient?.status || record.status || '-'}</span> },
      { title: "Mobile", key: "mobile", render: (_, record) => record.patient?.mobile || record.mobile || '-' },
      {
        title: "Actions",
        key: "actions",
        render: (_, record) => (
          <Button
            type="primary"
            onClick={() => {
              // console.log("Selected Record: ", record);
              navigate('/report/complete', { state: { report: record } });
            }}>
            Select
          </Button>
        )
      },
    ];

    setModalColumns(columns);
    setModalLoading(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setCurrentView("table");
    setSelectedRecord(null);
  };


  const reportCards = [
    {
      title: "Add Report",
      header: "Add",
      icon: <MdAdd className="text-4xl" />,
      bgColor: "bg-gradient-to-br from-blue-500 to-blue-600",
      iconBg: "bg-blue-100",
      iconColor: "text-blue-600",
      onClick: () => navigate("/report/add")
    },
    {
      title: "Print Reports",
      header: "Print",
      icon: <MdPrint className="text-4xl" />,
      bgColor: "bg-gradient-to-br from-purple-500 to-purple-600",
      iconBg: "bg-purple-100",
      iconColor: "text-purple-600",
      onClick: () => navigate("/report/print")
    },
    {
      title: "All Reports",
      header: "Manage",
      count: reports.length || data?.manager || 0,
      icon: <MdReport className="text-4xl" />,
      bgColor: "bg-gradient-to-br from-green-500 to-green-600",
      iconBg: "bg-green-100",
      iconColor: "text-green-600",
      onClick: () => navigate("/report/manage")
    },
    {
      title: `Pending (${reports.length})`,
      header: "Pending",
      icon: <MdPostAdd className="text-4xl" />,
      bgColor: "bg-gradient-to-br from-yellow-500 to-yellow-600",
      iconBg: "bg-yellow-100",
      iconColor: "text-yellow-600",
      onClick: () => showModal("Select Report", "doctor")
    },
  ];

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar onCollapse={setSidebarCollapsed} />
      <div className={` flex-1 p-6 transition-all duration-300 ${sidebarCollapsed ? 'ml-20' : 'ml-0'
        }`}>
        <div className="flex-1 p-6 ml-40">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-2">Report Overview</h1>
            <p className="text-gray-600">Create, update and manage reports</p>
          </div>

          {loading ? (
            <div className="flex items-center justify-center h-64">
              <div className="text-center">
                <Spin size="large" />
                <p className="mt-4 text-gray-600">Loading report data...</p>
              </div>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
              {reportCards.map((card, index) => (
                <div
                  key={index}
                  onClick={card.onClick}
                  className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 cursor-pointer transform hover:-translate-y-1"
                >
                  <div className="p-6">
                    <div className="flex items-center justify-between">
                      <div>
                        {card.header ?
                          <h1 className="text-2xl font-bold text-gray-800 mb-1"> {card.header} </h1> :
                          <h3 className="text-2xl font-bold text-gray-800 mb-1">
                            {card.count}
                          </h3>}
                        <p className="text-gray-600 text-sm font-medium">
                          {card.title}
                        </p>
                      </div>
                      <div className={`p-3 rounded-full ${card.iconBg}`}>
                        <div className={card.iconColor}>
                          {card.icon}
                        </div>
                      </div>
                    </div>
                    <div className="mt-4">
                      <div className={`h-1 rounded-full ${card.bgColor}`}></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          <Modal
            title={
              <div className="text-xl font-semibold text-gray-800">
                {"Select Test Order"}
              </div>
            }
            open={isModalVisible}
            onCancel={handleCancel}
            footer={[
              <Button key="back" onClick={handleCancel} className="bg-gray-500 hover:bg-gray-600">
                Close
              </Button>
            ]}
            width={currentView === "details" ? 800 : 1000}
            className="custom-modal"
          >
            {modalLoading ? (
              <div className="flex items-center justify-center py-8">
                <div className="text-center">
                  <Spin size="large" />
                  <p className="mt-4 text-gray-600">Loading data...</p>
                </div>
              </div>
            ) : (selectedRecord ?
              <div>
                <div className="flex p-3 mb-2 gap-3 justify-between items-center bg-gray-100 rounded-md">
                  <div>
                    <h1>Test ID: <span className="font-semibold ml-2">{selectedRecord._id || "No id found"}</span></h1>
                    <h1>Test for : <span className="font-semibold ml-2">{selectedRecord.patientName || "(Name not found)"}</span> </h1>
                    <h1>Mobile No. : <span className="font-semibold ml-2">{selectedRecord.mobile || "(Name not found)"}</span> </h1>
                    <h1>Address : <span className="font-semibold ml-2">{selectedRecord.address || "(Name not found)"}</span> </h1>
                    <h1>Created on (Date) : <span className="font-semibold ml-2">{selectedRecord.date || "(Name not found)"}</span> </h1>
                    <div>
                      Tests:
                      {selectedRecord?.tests?.map((t, idx) => (
                        <span key={idx} className={`{idx > 0 ? 'ml-2' : 'ml-1'} inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full ml-2 mb-1 hover:bg-blue-200`}>
                          {idx + 1}. <span className="inline font-semibold">{t.testName}</span>
                        </span>
                      ))}
                    </div>
                  </div>
                  <Button key="back" onClick={() => setSelectedRecord(null)}
                    className="bg-red-500 hover:bg-gray-600 flex gap-2 items-center group text-white">
                    Remove
                    <MdClose className="text-white group-hover:text-blue-300 transition-colors duration-200" />
                  </Button>
                </div>
                <div className="flex justify-end">
                  <Button
                    onClick={() => navigate('/report/complete', { state: { report: selectedRecord } })}
                    className="bg-green-400 hover:bg-green-300 py-2 px-5 rounded-lg text-black hover:text-gray-700 font-semibold">
                    Create Report for this Test
                  </Button>
                </div>
              </div> :
              <div>
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-2">
                  <div className="flex-1 w-full flex items-center gap-2 bg-gray-100 rounded-lg px-4 py-2 border-1 border-gray-700">
                    <Search className="w-5 h-5 text-gray-400" />
                    <Input
                      placeholder="Search by name, email, mobile, doctor, or agent"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="border-none bg-transparent focus:ring-0 focus:border-none"
                      style={{ width: 300, boxShadow: "none" }}
                    />
                  </div>
                  <div className="flex items-center gap-2 bg-gray-50 rounded-lg px-4 py-2 min-w-64">
                    <SortAscIcon className="w-5 h-5 text-gray-400" />
                    <Select
                      value={sortBy}
                      onChange={(value) => setSortBy(value)}
                      className="border-none bg-transparent focus:ring-0 text-gray-700 flex-1"
                      placeholder="Select Sort By"
                      options={[
                        { disabled: true, label: 'Select Sort By', value: '' },
                        { value: 'createdAt:asc', label: 'Created At (Oldest)' },
                        { value: 'createdAt:desc', label: 'Created At (Newest)' },
                        { value: 'updatedAt:asc', label: 'Updated At (Oldest)' },
                        { value: 'updatedAt:desc', label: 'Updated At (Newest)' },
                      ]}
                    >
                    </Select>
                  </div>
                </div>

                <Table
                  columns={modalColumns}
                  dataSource={reports.map((item, index) => ({ ...item, key: index }))}
                  pagination={{ pageSize: 5 }}
                  className="custom-table"
                />
              </div>
            )}
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default Report;